export default {"src":"/_next/static/media/sitathomeprice.f53c1822.svg","height":16,"width":16,"blurWidth":0,"blurHeight":0};